import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchUserInfo, resetStatus } from "../redux/usersSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { Permissions } from "./Permissions";
import { UserInfo } from "./UserInfo";
import { Settings } from "./Settings";
import { ErrorList } from "./ErrorList";
import { useError } from "../hooks/useError";
import { useEdit } from "../hooks/useEdit";
import { showToast } from "../../../../utils/showToast";

export const Edit = ({
  isOpen,
  onClose,
  selected: { statuses: { isAdmin } = {}, id, orgName }
}) => {
  const dispatch = useDispatch();

  const {
    form: { register, control, setValue, watch, formState: { errors, isDirty } = {} } = {},
    submit,
    linkUsersToSharePermissions,
    watchedValues,
    orgRoles,
    currentUserInfo,
    allPermissions,
    organizations
  } = useEdit({ isAdmin, id, orgName });

  let {
    firstName,
    lastName,
    createdBy,
    userActions: {
      canChangeUserEmail,
      canChange2FA,
      canChangeRole,
      canChangeEmails,
      canUpdateLocations,
      canSendInactiveUsersEmail,
      canUpdateCorporateReports
    } = {}
  } = currentUserInfo || {};

  const [activeTab, setActiveTab] = useState(0);

  const close = () => {
    dispatch(resetStatus());
    onClose();
  };

  useEffect(() => {
    dispatch(fetchUserInfo(id));
  }, []);

  const { errors: serverErrors, status } = useError(() => {
    showToast("User was successfully updated");
    close();
  });

  const primaryButtonDisabled = !isDirty || status == "pending";

  const activeTabClassName = "tabs__tab--active";

  const renderPermissions = () => (
    <Permissions
      watch={watch}
      setValue={setValue}
      allPermissions={allPermissions}
      control={control}
      register={register}
      canUpdateLocations={canUpdateLocations}
      canChangeEmails={canChangeEmails}
      canUpdateCorporateReports={canUpdateCorporateReports}
      canSendInactiveUsersEmail={canSendInactiveUsersEmail}
    />
  );

  const renderUserInfo = () => (
    <UserInfo
      register={register}
      control={control}
      canChange2FA={canChange2FA}
      canChangeUserEmail={canChangeUserEmail}
      createdBy={createdBy}
    />
  );

  const renderActiveTab = () => {
    if (activeTab === 0) {
      return renderUserInfo();
    } else if (activeTab == 1) {
      return renderPermissions();
    }

    return (
      <Settings
        isAdmin={isAdmin}
        watchedValues={watchedValues}
        orgRoles={orgRoles}
        canChangeRole={canChangeRole}
        register={register}
        control={control}
        organizations={organizations}
        linkUsersToSharePermissions={linkUsersToSharePermissions}
      />
    );
  };

  return (
    <>
      <MainModal
        isLoading={!currentUserInfo}
        parentSelector=".admin-users"
        isOpen={isOpen}
        onClose={close}
        headerText={
          <>
            Edit User -{" "}
            <span className="text-bold">
              {lastName}, {firstName}
            </span>
          </>
        }
        headerCloseHandler={close}
        height="auto"
        width={900}
        primaryButtonText="Save"
        primaryBtnHandler={submit}
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        secondaryBtnClass="secondary"
        containerClassName="edit"
        isAdminPanel={false}
      >
        {!isAdmin && (
          <div className="tabs">
            <div className="tabs__list">
              <button
                className={`tabs__tab ${activeTab === 0 ? activeTabClassName : ""}`}
                onClick={() => setActiveTab(0)}
              >
                User Info
              </button>
              <button
                className={`tabs__tab ${activeTab === 1 ? activeTabClassName : ""}`}
                onClick={() => setActiveTab(1)}
              >
                Permissions
              </button>
              <button
                className={`tabs__tab ${activeTab === 2 ? activeTabClassName : ""}`}
                onClick={() => setActiveTab(2)}
              >
                Clubready
              </button>
            </div>

            <div id="hook-form">{renderActiveTab()}</div>
          </div>
        )}
        {isAdmin && renderUserInfo()}
        {status === "pending" && <LoadingAnimation uiLoader />}

        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
